import React from 'react'
import { Link, Outlet } from 'react-router-dom'

const CandSettings = () => {
    return (
        <div className="content ">
            <div className='px-4' >
                <h1 className="text-3xl font-bold text-left">Settings</h1>
                <p className="text-gray-700 mt-3 text-lg">
                    You can manage your settings from here
                </p>
            </div>
            <div className='flex mt-6 border-b px-4'>
                <Link
                    className='w-full text-center py-4 text-lg text-gray-600 hover:text-blue-600 border-b-2 hover:border-blue-600  transition duration-200'
                    to="/candidate-dashboard/settings/"
                >
                    Account Settings
                </Link>
                <Link
                    className='w-full text-center py-4 text-lg text-gray-600 hover:text-blue-600 border-b-2 hover:border-blue-600 transition duration-200'
                    to="/candidate-dashboard/settings/email-setting"
                >
                    Email Settings
                </Link>
                <Link
                    className='w-full text-center py-4 text-lg text-gray-600 hover:text-blue-600 border-b-2 hover:border-blue-600 transition duration-200'
                    to="/candidate-dashboard/settings/privacy-settings"
                >
                    Privacy Settings
                </Link>
            </div>

            <div className="mt-6 px-4">
                <Outlet />
            </div>
        </div>
    )
}

export default CandSettings